import { GaTrackingPayloadSend } from '@porterin/component-library/src/ts-utils/analytics/react-ga/types/GaTrackingPayload';
import ReactGA from 'react-ga4';
import { getGaTrackingIdByLocale } from '../EventTracker';

export const publishGaEvent = (payload: GaTrackingPayloadSend): void => {
  ReactGA.send(payload);
};

export const publishGaEventParameter = <T extends Record<string, any>>(
  event_name: string,
  payload: T,
): void => {
  const gaPayload = { ...payload, send_to: getGaTrackingIdByLocale() };
  ReactGA.event(event_name, gaPayload);
};
